/* eslint-disable no-unused-vars */
export interface IColumn {
    name: ColumnNames;
    title?: ColumnTitles;
    filterable?: boolean;
  }

export enum ColumnNames {
    pair = 'pair',
    price = 'price_a_usd',
    liquidity = 'liquidity',
    volume = 'volume',
    exchange = 'exchange',
    star = 'star',
    contract = 'contract',
    apy = 'annual_percentage_yield',
  }

export enum ColumnTitles {
    pair = 'Pairs',
    price = 'Price',
    liquidity = 'Liquidity',
    volume = 'Volume',
    contract = 'Contract',
    apy = 'APY'
  }